import script from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"

import "./FormGroup.vue?vue&type=style&index=0&id=cd7aceb6&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd7aceb6"]])

export default __exports__